import { MomaTracesControl } from "../controls/MomaTracesControl";
import { getMomaTracesLayer } from "../layers/MomaTracesLayer";
import { getMomaTracesInteractions } from "../layers/interactions/momaTraces";
import {
  registerMomaControl,
  getMomaToggleFromURL,
} from "../state/URLStateManager";

// MoMa session traces overlay: while toggled on, session traces for the current
// viewport are fetched automatically from the moma-traces proxy (which holds the
// MoMa API key server-side) on every map move past the zoom gate.
//
// MOMA_TRACES_URL comes from .env.{local,development,production}. For local dev
// run the proxy first:
//   MOMA_API_KEY=... node infra/functions/moma-traces/local-server.mjs
export function addMomaLayersAndControls(map, target, layerGroup) {
  // Fall back to the local dev proxy only when the app itself runs on localhost;
  // on deployed hosts an unset MOMA_TRACES_URL means the backend isn't wired yet
  // (fetching http://localhost from an https page is blocked by the browser).
  const isLocalhost = ["localhost", "127.0.0.1"].includes(
    window.location.hostname,
  );
  const momaTracesUrl =
    process.env.MOMA_TRACES_URL ||
    (isLocalhost ? "http://localhost:7345/api/moma-traces" : null);

  const momaTracesControl = new MomaTracesControl({ target: target });
  map.addControl(momaTracesControl);
  registerMomaControl(momaTracesControl);

  if (!momaTracesUrl) {
    momaTracesControl.set(
      "momaStatus",
      "backend not deployed (MOMA_TRACES_URL unset)",
    );
    momaTracesControl.setDisabled(true);
    return { momaTracesControl, momaTracesLayer: null };
  }

  const layer = getMomaTracesLayer(map, momaTracesControl, momaTracesUrl);
  if (layerGroup) {
    layerGroup.getLayers().push(layer);
  } else {
    map.addLayer(layer);
  }

  getMomaTracesInteractions(layer, momaTracesControl).forEach((interaction) =>
    map.addInteraction(interaction),
  );

  // Restore after the layer has subscribed to the control, so ?moma=1 triggers
  // the initial viewport fetch.
  momaTracesControl.restoreState(getMomaToggleFromURL());

  return { momaTracesControl, momaTracesLayer: layer };
}
